// components/Footer.jsx — Site footer with brand, copyright, language switcher

export default function Footer({ content, logo, dark, lang, setLang, t }) {
  const year = new Date().getFullYear();

  return (
    <footer
      className={`py-10 px-4 border-t ${
        dark
          ? "bg-[#0F172A] border-white/10 text-white"
          : "bg-white border-[#E2E8F0] text-[#0F172A]"
      }`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Brand */}
          <div className="text-center sm:text-left">
            <div className="flex items-center justify-center sm:justify-start" style={{ gap: 12 }}>
              {(logo?.imageUrl || logo?.imageDarkUrl) ? (
                <>
                  <img
                    src={dark ? (logo?.imageDarkUrl || logo?.imageUrl) : (logo?.imageUrl || logo?.imageDarkUrl)}
                    alt={logo?.text || content.brand}
                    className="h-8 w-auto object-contain"
                  />
                  {logo?.text && (
                    <span className="text-lg font-bold">
                      <span className="text-[#A3E635]">{logo.text.slice(0, 3)}</span>
                      {logo.text.slice(3)}
                    </span>
                  )}
                </>
              ) : (
                <span className="text-lg font-bold">
                  <span className="text-[#A3E635]">{content.brand?.slice(0, 3)}</span>
                  {content.brand?.slice(3)}
                </span>
              )}
            </div>
            {content.tagline && (
              <p className={`text-xs mt-0.5 ${dark ? "text-white/35" : "text-[#0F172A]/35"}`}>
                {content.tagline}
              </p>
            )}
          </div>

          {/* Nav links */}
          <div className={`flex flex-wrap gap-5 text-xs ${dark ? "text-white/40" : "text-[#0F172A]/40"}`}>
            <a href="#services" className="hover:text-[#A3E635] transition-colors">{t.nav.services}</a>
            <a href="#portfolio" className="hover:text-[#A3E635] transition-colors">{t.nav.portfolio}</a>
            <a href="#howItWorks" className="hover:text-[#A3E635] transition-colors">{t.nav.howItWorks}</a>
            <a href="#pricing" className="hover:text-[#A3E635] transition-colors">{t.nav.pricing}</a>
            <a href="#testimonials" className="hover:text-[#A3E635] transition-colors">{t.nav.testimonials}</a>
            <a href="#contact" className="hover:text-[#A3E635] transition-colors">{t.nav.contact}</a>
            <a href="https://blog.webilo.es" target="_blank" rel="noopener noreferrer" className="hover:text-[#A3E635] transition-colors">Blog</a>
          </div>

          {/* Language switcher */}
          <div className="flex items-center gap-2">
            <span className={`text-xs ${dark ? "text-white/35" : "text-[#0F172A]/35"}`}>
              {t.footer.language}:
            </span>
            <button
              onClick={() => setLang("en")}
              className={`text-xs px-2.5 py-1 rounded-lg border transition-all ${
                lang === "en"
                  ? "border-[#A3E635] text-[#A3E635] bg-[#A3E635]/5"
                  : dark
                  ? "border-white/15 text-white/40 hover:border-white/30"
                  : "border-[#E2E8F0] text-[#0F172A]/40 hover:border-[#0F172A]/30"
              }`}
            >
              🇬🇧 EN
            </button>
            <button
              onClick={() => setLang("es")}
              className={`text-xs px-2.5 py-1 rounded-lg border transition-all ${
                lang === "es"
                  ? "border-[#A3E635] text-[#A3E635] bg-[#A3E635]/5"
                  : dark
                  ? "border-white/15 text-white/40 hover:border-white/30"
                  : "border-[#E2E8F0] text-[#0F172A]/40 hover:border-[#0F172A]/30"
              }`}
            >
              🇪🇸 ES
            </button>
          </div>
        </div>

        {/* Copyright */}
        <div className={`mt-6 pt-6 border-t text-center text-xs ${dark ? "border-white/10 text-white/25" : "border-[#E2E8F0] text-[#0F172A]/25"}`}>
          {content.copyright || `© ${year} ${content.brand}. ${t.footer.rights}`}
        </div>
      </div>
    </footer>
  );
}
